import { Loader } from '@symphony-ui/uitoolkit-components';
import DebouncedInput from 'components/custom-table/filters/DebouncedInput';
import * as React from 'react';
import ApiServerRequest from 'models/ApiServerRequest';
import DownloadContext from 'contexts/DownloadContext';
import ApiServerURL from 'models/ApiServerUrl';
import { sendFetchError } from 'utils/messageUtils';
import IFRStoryV2 from './IFRStoryV2';
import IFRStreamItemV2 from './IFRStreamItemV2';
const IFRPanelV2 = ({ className = "", isVisible, ref }) => {
    const { apiFetchJson } = React.useContext(DownloadContext);
    const [ifrError, setIfrError] = React.useState();
    const [ifrLoading, setIfrLoading] = React.useState(false);
    const [items, setItems] = React.useState([]);
    const [search, setSearch] = React.useState('');
    const onChangeSearch = React.useCallback((value) => {
        setSearch(value);
    }, []);
    React.useEffect(() => {
        const abortController = new AbortController();
        (async () => {
            const url = new ApiServerURL('/syndicate/ifr/v2/all');
            if (search.length > 2) {
                url.searchParams.append('search', search);
            }
            const request = new ApiServerRequest(url);
            try {
                setIfrLoading(true);
                const body = await apiFetchJson(request, abortController.signal);
                const downloaded = body.map(r => new IFRStoryV2(r));
                setItems(downloaded);
            }
            catch (error) {
                if (!(error instanceof Error && error.name === 'AbortError')) {
                    sendFetchError('Unable to download IFR stories', error, request);
                    setIfrError("Unable to download transactions");
                }
            }
            finally {
                setIfrLoading(false);
            }
        })();
    }, [apiFetchJson, search]);
    //    return (<div className={`${className}${isVisible ? ' co-visible' : ''}`} ref={ref} >
    return (React.createElement("div", { style: { height: '100%' } },
        React.createElement("div", { style: { display: 'flex', paddingBottom: '0.5rem' } },
            React.createElement("div", { style: { paddingLeft: '1rem', paddingRight: '1rem', width: '100%' } },
                React.createElement(DebouncedInput, { debounce: 200, onChange: onChangeSearch, placeholder: "Search", value: search }))),
        !ifrLoading && ifrError === undefined
            ? (React.createElement("div", { style: { height: '100%', overflowY: 'scroll' } }, items.map((m) => (React.createElement(IFRStreamItemV2, { key: m.id, story: m })))))
            : (React.createElement("div", { className: "loader-wrapper3" }, ifrLoading ? React.createElement(Loader, { className: "co-center-page", type: "spinner", variant: "primary" }) : React.createElement("p", null, ifrError)))));
};
export default IFRPanelV2;
